import type { FC, SVGProps } from 'react'

import { cn } from '@/lib/utils'

type MarkProps = SVGProps<SVGSVGElement>

const RAY_BANDS: Array<[number, number]> = [
    [5, 1.4],
    [7.6, 1.6],
    [10.2, 3.6],
    [14.8, 1.6],
    [17.6, 1.4]
]

export const RayMark: FC<MarkProps> = ({ className, ...props }) => (
    <svg
        viewBox='0 0 24 24'
        fill='currentColor'
        aria-hidden='true'
        className={cn('shrink-0', className)}
        {...props}
    >
        <g transform='rotate(45 12 12)'>
            {RAY_BANDS.map(([x, width]) => (
                <rect
                    key={x}
                    x={x}
                    y={5}
                    width={width}
                    height={14}
                    rx={width > 2 ? 0.6 : 0.5}
                />
            ))}
        </g>
    </svg>
)

export const NuPhyMark: FC<{ className?: string }> = ({ className }) => (
    <span
        aria-hidden='true'
        className={cn('flex flex-col items-center font-black uppercase leading-[0.82] tracking-[-0.06em]', className)}
    >
        <span>
            ‹nu›
        </span>

        <span>
            phy
        </span>
    </span>
)

export const AppleLogo: FC<MarkProps> = ({ className, ...props }) => (
    <svg
        viewBox='0 0 24 24'
        fill='currentColor'
        aria-hidden='true'
        className={cn('shrink-0', className)}
        {...props}
    >
        <path d='M12.152 6.896c-.948 0-2.415-1.078-3.96-1.04-2.04.027-3.91 1.183-4.961 3.014-2.117 3.675-.546 9.103 1.519 12.09 1.013 1.454 2.208 3.09 3.792 3.039 1.52-.065 2.09-.987 3.935-.987 1.831 0 2.35.987 3.96.948 1.637-.026 2.676-1.48 3.676-2.948 1.156-1.688 1.636-3.325 1.662-3.415-.039-.013-3.182-1.221-3.22-4.857-.026-3.04 2.48-4.494 2.597-4.559-1.429-2.09-3.623-2.324-4.39-2.376-2-.156-3.675 1.09-4.61 1.09zM15.53 3.83c.843-1.012 1.4-2.427 1.245-3.83-1.207.052-2.662.805-3.532 1.818-.78.896-1.454 2.338-1.273 3.714 1.338.104 2.715-.688 3.559-1.701' />
    </svg>
)

export const WindowsLogo: FC<MarkProps> = ({ className, ...props }) => (
    <svg
        viewBox='0 0 24 24'
        fill='currentColor'
        aria-hidden='true'
        className={cn('shrink-0', className)}
        {...props}
    >
        <path d='M3 3h8.4v8.4H3zM12.6 3H21v8.4h-8.4zM3 12.6h8.4V21H3zM12.6 12.6H21V21h-8.4z' />
    </svg>
)

export const HyperStar: FC<MarkProps> = ({ className, ...props }) => (
    <svg
        viewBox='0 0 24 24'
        fill='currentColor'
        aria-hidden='true'
        className={cn('shrink-0', className)}
        {...props}
    >
        <path d='M12 2c.55 5.3 4.7 9.45 10 10-5.3.55-9.45 4.7-10 10-.55-5.3-4.7-9.45-10-10 5.3-.55 9.45-4.7 10-10z' />
    </svg>
)
